export const ResidentialUserProfileSelectors = {
  block: "ResidentialUserProfile",
  submit: "ResidentialUserProfile__submit",
  market: "ResidentialUserProfile__market",
  building: "ResidentialUserProfile__building",
  registrationInstructions: "ResidentialUserProfile__registrationInstructions",
  apartmentNumber: "ResidentialUserProfile__apartmentNumber",
  deliveryPreferenceToggle: "ResidentialUserProfile__deliveryPreferenceToggle",
  deliveryPreferenceExplanation:
    "ResidentialUserProfile__deliveryPreferenceExplanation",
  setByBuilding: "ResidentialUserProfile__setByBuilding",
  tcpField: "ResidentialUserProfile__tcpField",
  tcpLinks: "ResidentialUserProfile__tcpLinks",
};
